import React, { useEffect, useRef, useState } from "react";
import { triIcon } from "./SVG";

const Select = ({ selected = null, list, keyInput = null, onChange }) => {
  const wrapper = useRef(null);
  const [active, setActive] = useState(false);
  const [currentList, setCurrentList] = useState(list);
  const [currentSelected, setCurrentSelected] = useState(selected);

  const onClick = (item) => {
    setCurrentSelected(item);
    if (onChange) onChange(item);

    setActive(false);
  };

  const toggleActive = () => {
    setActive(!active);
  };

  useEffect(() => {
    setCurrentList(
      !currentSelected
        ? list
        : list.filter((item) => {
            let compareKey = keyInput ?? "value";
            return item[compareKey] !== currentSelected[compareKey];
          })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list, currentSelected]);

  useEffect(() => {
    setCurrentSelected(selected);
  }, [selected]);

  useEffect(() => {
    const windowClick = ({ target }) => {
      if (!wrapper.current.contains(target)) setActive(false);
    };

    if (active) window.addEventListener("click", windowClick);
    else window.removeEventListener("click", windowClick);

    return () => window.removeEventListener("click", windowClick);
  }, [active]);

  return (
    <div className={"select " + (active ? "active" : "")} ref={wrapper}>
      <div className="select__selected" onClick={toggleActive}>
        {currentSelected ? currentSelected.value : "-----"}
        {triIcon}
      </div>
      <div className="select__options">
        {currentList.map((item, index) => (
          <div
            className="select__item"
            key={index}
            onClick={() => onClick(item)}
          >
            {item.value}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Select;
